import { render } from "./ModuleCopyCarousel.vue?vue&type=template&id=7f524948"
import script from "./ModuleCopyCarousel.vue?vue&type=script&lang=js"
export * from "./ModuleCopyCarousel.vue?vue&type=script&lang=js"

import "./ModuleCopyCarousel.vue?vue&type=style&index=0&id=7f524948&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__